module.exports = __webpack_public_path__ + "static/media/binoculars.d80b6715.svg";